import { createSlice } from '@reduxjs/toolkit';

// Load persisted auth state from localStorage
const loadAuthState = () => {
  try {
    const serializedState = localStorage.getItem('authState');
    if (serializedState === null) {
      return {
        isAuthenticated: false,
        user: null,
        registerNumber: null,
        takeawayList: [],
        loading: false,
        error: null,
      };
    }
    const parsed = JSON.parse(serializedState);
    // Only restore if takeawayList exists (user was logged in)
    if (parsed.takeawayList && parsed.takeawayList.length > 0) {
      return {
        isAuthenticated: true,
        user: parsed.user,
        registerNumber: parsed.registerNumber,
        takeawayList: parsed.takeawayList,
        loading: false,
        error: null,
      };
    }
    return {
      isAuthenticated: false,
      user: null,
      registerNumber: null,
      takeawayList: [],
      loading: false,
      error: null,
    };
  } catch (err) {
    console.error('Error loading auth state from localStorage:', err);
    return {
      isAuthenticated: false,
      user: null,
      registerNumber: null,
      takeawayList: [],
      loading: false,
      error: null,
    };
  }
};

const initialState = loadAuthState();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.registerNumber = null;
      state.takeawayList = [];
      state.error = null;
      // Clear localStorage on logout
      try {
        localStorage.removeItem('authState');
      } catch (err) {
        console.error('Error clearing auth state from localStorage:', err);
      }
    },
    setRegisterNumber: (state, action) => {
      state.registerNumber = action.payload;
    },
    setTakeawayList: (state, action) => {
      state.takeawayList = action.payload;
      // If takeawayList is set, user should be authenticated
      if (action.payload && action.payload.length > 0) {
        state.isAuthenticated = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLoading,
  loginSuccess,
  loginFailure,
  logout,
  setRegisterNumber,
  setTakeawayList,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;


